var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-keyword-query-render" }, [
    _c(
      "h5",
      { staticClass: "ai-common-suggestion-board__block-title" },
      [
        _c("PtIcon", {
          staticClass: "ai-common-suggestion-field-item__description-icon",
          attrs: { icon: "GptAvatar" },
        }),
        _c("span", [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("smartSearch.keywordQueryTitle", {
                  keyword: _vm.keyword,
                })
              ) +
              " "
          ),
        ]),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "block-keyword-query__main",
        on: { mousedown: _vm.handleClick },
      },
      _vm._l(_vm.items, function (item) {
        return _c(
          "div",
          { key: item.index, staticClass: "block-keyword-query__item" },
          [
            _c("span", { staticClass: "block-keyword-query__item-logic" }, [
              _vm._v("OR"),
            ]),
            _c("span", { staticClass: "block-keyword-query__item-keyword" }, [
              _vm._v(_vm._s(item.value)),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }